@let isCollapsed = collapsed();

<nav
  class="mbs-side-nav"
  [attr.data-e2e]="elementSelectors.name.root"
  [class.-collapsed]="isCollapsed">
  <div class="mbs-side-nav_brand">
    @let logo = logoUrl();

    @if (!isCollapsed && logo) {
      @let appEnvStateValue = appEnvState();

      <a
        class="mbs-side-nav_logo"
        [attr.title]="
          appEnvStateValue?.type === 'STAGE' ? appEnvStateValue.type.toLocaleUpperCase() + ' / ' + appEnvStateValue.version : null
        "
        [routerLink]="homePageUrl">
        @if (isRebranded()) {
          <img
            class="mbs-side-nav_logo-img mw-100"
            [alt]="'shared:header.texts.homePage' | i18next"
            [src]="logo" />
        } @else {
          <img
            alt="MSP360"
            height="21"
            width="119"
            [src]="logo" />
        }
      </a>
    }

    <button
      class="mbs-side-nav_toggle"
      container="body"
      placement="right"
      type="button"
      [attr.data-e2e]="elementSelectors.name.collapseToggle"
      [class.ml-auto]="!isCollapsed && !logo"
      (click)="handleToggleCollapse()">
      <span [ngClass]="isCollapsed ? 'ico ico-open-menu-left' : 'ico ico-hide-menu-left'"></span>
    </button>
  </div>

  <ul class="nav flex-column mbs-side-nav_list">
    @for (item of filterCanMenus(menu()); track item.id) {
      @if (hasSeparatorBefore(item)) {
        <li class="mbs-side-nav_divider"></li>
      }

      @if (item.children?.length > 0) {
        @if (isCollapsed) {
          <li
            #flyout="ngbDropdown"
            autoClose="outside"
            class="nav-item mbs-side-nav_group"
            container="body"
            ngbDropdown
            placement="end-top"
            [class.-active]="isGroupActive(item)"
            [popperOptions]="flyoutPopperOptions">
            <button
              #groupTooltip="ngbTooltip"
              class="nav-link mbs-side-nav_link -no-arrow"
              container="body"
              ngbDropdownToggle
              placement="right"
              type="button"
              [disableTooltip]="flyout.isOpen()"
              [id]="'side-nav-' + item.id"
              [ngbTooltip]="getGroupTooltip(item)"
              (click)="groupTooltip.close()">
              <ng-container *ngTemplateOutlet="itemBody; context: { item: item, iconOnly: true }"></ng-container>
            </button>

            <div
              class="mbs-side-nav_flyout"
              ngbDropdownMenu>
              @if (flyout.isOpen()) {
                <ul class="nav flex-column mbs-side-nav_list">
                  <ng-container *ngTemplateOutlet="groupChildren; context: { item: item, inFlyout: true }"></ng-container>
                </ul>
              }
            </div>
          </li>
        } @else {
          @let isGroupExpanded = isExpanded(item);

          <li
            class="nav-item mbs-side-nav_group"
            [class.-active]="isGroupActive(item)"
            [class.-expanded]="isGroupExpanded">
            <button
              class="nav-link mbs-side-nav_link"
              type="button"
              [id]="'side-nav-' + item.id"
              (click)="handleToggleGroup(item)">
              <ng-container *ngTemplateOutlet="itemBody; context: { item: item, iconOnly: false }"></ng-container>

              <span
                class="fa mbs-side-nav_chevron"
                [class.fa-angle-down]="isGroupExpanded"
                [class.fa-angle-right]="!isGroupExpanded"></span>
            </button>

            @if (isGroupExpanded) {
              <ul class="nav flex-column mbs-side-nav_sublist">
                <ng-container *ngTemplateOutlet="groupChildren; context: { item: item, inFlyout: false }"></ng-container>
              </ul>
            }
          </li>
        }
      } @else {
        <ng-container *ngTemplateOutlet="navItem; context: { item: item, iconOnly: isCollapsed }"></ng-container>
      }
    }
  </ul>
</nav>

<ng-template
  #groupChildren
  let-inFlyout="inFlyout"
  let-item="item">
  @for (child of filterCanMenus(item.children); track child.id) {
    @if (child.isHorizontalDivider) {
      <li class="mbs-side-nav_divider"></li>
    } @else if (child.children?.length > 0) {
      @if (inFlyout) {
        <li
          #subFlyout="ngbDropdown"
          autoClose="outside"
          class="nav-item mbs-side-nav_group"
          ngbDropdown
          placement="end-top"
          [class.-active]="isGroupActive(child)"
          [popperOptions]="flyoutPopperOptions">
          <button
            class="nav-link mbs-side-nav_link -no-arrow"
            ngbDropdownToggle
            type="button"
            [id]="'side-nav-' + child.id">
            <ng-container *ngTemplateOutlet="itemBody; context: { item: child, iconOnly: false }"></ng-container>

            <span class="fa fa-angle-right mbs-side-nav_chevron"></span>
          </button>

          <div
            class="mbs-side-nav_flyout"
            ngbDropdownMenu>
            @if (subFlyout.isOpen()) {
              <ul class="nav flex-column mbs-side-nav_list">
                @for (subChild of filterCanMenus(child.children); track subChild.id) {
                  <ng-container *ngTemplateOutlet="navItem; context: { item: subChild, iconOnly: false }"></ng-container>
                }
              </ul>
            }
          </div>
        </li>
      } @else {
        @let isSubGroupExpanded = isExpanded(child);

        <li
          class="nav-item mbs-side-nav_group"
          [class.-active]="isGroupActive(child)">
          <button
            class="nav-link mbs-side-nav_link"
            type="button"
            [id]="'side-nav-' + child.id"
            (click)="handleToggleGroup(child)">
            <ng-container *ngTemplateOutlet="itemBody; context: { item: child, iconOnly: false }"></ng-container>

            <span
              class="fa mbs-side-nav_chevron"
              [class.fa-angle-down]="isSubGroupExpanded"
              [class.fa-angle-right]="!isSubGroupExpanded"></span>
          </button>

          @if (isSubGroupExpanded) {
            <ul class="nav flex-column mbs-side-nav_sublist">
              @for (subChild of filterCanMenus(child.children); track subChild.id) {
                <ng-container *ngTemplateOutlet="navItem; context: { item: subChild, iconOnly: false }"></ng-container>
              }
            </ul>
          }
        </li>
      }
    } @else {
      <ng-container *ngTemplateOutlet="navItem; context: { item: child, iconOnly: false }"></ng-container>
    }
  }
</ng-template>

<ng-template
  #navItem
  let-iconOnly="iconOnly"
  let-item="item">
  @let isActive = isActiveMenuItem(item);

  <li
    class="nav-item"
    [class.active]="isActive">
    @if (item.externalUrl) {
      <a
        class="nav-link mbs-side-nav_link"
        container="body"
        placement="right"
        [href]="item.externalUrl"
        [ngbTooltip]="iconOnly ? item.name : ''"
        [target]="item.target || '_self'"
        (click)="handleItemClick(item)">
        <ng-container *ngTemplateOutlet="itemBody; context: { item: item, iconOnly: iconOnly }"></ng-container>
      </a>
    } @else if (item.action) {
      <button
        class="nav-link mbs-side-nav_link"
        container="body"
        placement="right"
        type="button"
        [attr.data-e2e]="item.e2eKey || ''"
        [ngbTooltip]="iconOnly ? item.name : ''"
        (click)="handleItemClick(item); item.action()">
        <ng-container *ngTemplateOutlet="itemBody; context: { item: item, iconOnly: iconOnly }"></ng-container>
      </button>
    } @else {
      <a
        class="nav-link mbs-side-nav_link"
        container="body"
        placement="right"
        [ngbTooltip]="iconOnly ? item.name : ''"
        [queryParams]="item.queryParams"
        [routerLink]="isActive ? null : item.routeUrl"
        (click)="handleItemClick(item)">
        <ng-container *ngTemplateOutlet="itemBody; context: { item: item, iconOnly: iconOnly }"></ng-container>
      </a>
    }
  </li>
</ng-template>

<ng-template
  #itemBody
  let-iconOnly="iconOnly"
  let-item="item">
  <span
    class="nav-link_ico mbs-side-nav_ico"
    [class.app-update-dot]="iconOnly && dot()[item.dotType]"
    [class.mbs-side-nav_dot]="iconOnly && dot()[item.dotType]"
    [ngClass]="item.iconClass"></span>

  @if (!iconOnly) {
    <span
      class="mbs-side-nav_label"
      [class.app-update-dot]="dot()[item.dotType]"
      [class.mbs-side-nav_dot]="dot()[item.dotType]">
      {{ item.name }}{{ item.secondName ? ' ' + item.secondName : '' }}
    </span>
  }
</ng-template>
